import React from 'react';
import './CallToAction.css';

const CallToAction = () => {
  return (
    <section className="call-to-action">
      <div className="cta-background">
        <div className="cta-overlay"></div>
      </div>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Join us and make an impact</h2>
          <div className="cta-buttons">
            <button className="cta-btn primary">Become a Member</button>
            <button className="cta-btn secondary">Become a Donor</button>
            <button className="cta-btn tertiary">Start a Programme</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
